export const applications = {
  // Hero
  heroTitle: 'Uygulamalar',
  heroSubtitle: 'Dünya çapında kritik altyapı ve inşaat projelerinde kanıtlanmış performans.',
  
  // Intro
  introTitle: 'Çok Yönlü Çelik Donatı Teli Çözümleri',
  introDesc: 'DYNAMIX kancalı uçlu çelik donatı telleri, modern inşaatın zorlu gereksinimlerini karşılamak için tasarlanmıştır. Endüstriyel zeminlerden tünel kaplamalarına kadar, tellerimiz geniş bir uygulama yelpazesinde tutarlı performans ve güvenilirlik sunar.',
  
  // Applications
  app1Title: 'Endüstriyel ve Ticari Zeminler',
  app1Desc: 'Yoğun trafikli depolar, dağıtım merkezleri, üretim tesisleri ve perakende alanları dayanıklı zemin çözümleri gerektirir. DYNAMIX çelik donatı telleri, üstün çatlak kontrolü, darbe direnci ve yük taşıma kapasitesi sağlayarak bakım maliyetlerini azaltır ve zemin hizmet ömrünü uzatır.',
  app1Benefits: 'Faydalar',
  app1Benefit1: 'Kaynaklı tel hasır ihtiyacını ortadan kaldırır',
  app1Benefit2: 'Döşeme kalınlığı gereksinimlerini azaltır',
  app1Benefit3: 'Ağır yüklere karşı direnci artırır',
  app1Benefit4: 'Derz bakımını minimize eder',
  
  app2Title: 'Tünel Kaplamaları',
  app2Desc: 'Yeraltı altyapısı olağanüstü dayanıklılık ve güvenlik gerektirir. Çelik donatı telli püskürtme beton, tünel inşaatında üstün performans sağlar, zorlu yeraltı ortamlarında mükemmel çatlak kontrolü, darbe direnci ve uzun vadeli yapısal bütünlük sunar.',
  app2Benefits: 'Faydalar',
  app2Benefit1: 'Gelişmiş püskürtme beton aderansı',
  app2Benefit2: 'Üstün çatlak direnci',
  app2Benefit3: 'İnşaat sırasında gelişmiş güvenlik',
  app2Benefit4: 'Püskürtme beton uygulamasında azaltılmış geri tepme',
  
  app3Title: 'Köprü Tabliyesi ve Altyapı',
  app3Desc: 'Karayolu ve demiryolu köprüleri sürekli trafik yüklerine ve çevresel maruziyete maruz kalır. DYNAMIX çelik donatı telleri beton dayanıklılığını artırır, termal stres ve büzülmeden kaynaklanan çatlamaları kontrol eder ve donma-çözülme döngülerine ve buz çözücü kimyasallara karşı direnci artırır.',
  app3Benefits: 'Faydalar',
  app3Benefit1: 'Uzatılmış hizmet ömrü',
  app3Benefit2: 'Azaltılmış bakım gereksinimleri',
  app3Benefit3: 'Gelişmiş yorulma direnci',
  app3Benefit4: 'Zorlu koşullarda daha iyi dayanıklılık',
  
  app4Title: 'Prefabrik Beton Elemanlar',
  app4Desc: 'Mimari ve yapısal prefabrik bileşenler, çelik donatı teli güçlendirmesinin gelişmiş özelliklerinden faydalanır. Tellerimiz taşıma dayanımını artırır, kalıptan çıkarma ve nakliye sırasında çatlamayı azaltır ve performanstan ödün vermeden daha ince, daha hafif elemanlara olanak tanır.',
  app4Benefits: 'Faydalar',
  app4Benefit1: 'Daha hızlı üretim döngüleri',
  app4Benefit2: 'Azaltılmış eleman kalınlığı',
  app4Benefit3: 'Gelişmiş yüzey kalitesi',
  app4Benefit4: 'Daha düşük nakliye maliyetleri',
  
  app5Title: 'Hidrolik Yapılar',
  app5Desc: 'Barajlar, su arıtma tesisleri ve deniz yapıları, sürekli su maruziyetine ve hidrolik kuvvetlere dayanabilecek beton gerektirir. Çelik donatı teli güçlendirmesi, ıslak ortamlarda mükemmel çatlak kontrolü, aşınma direnci ve dayanıklılık sağlar.',
  app5Benefits: 'Faydalar',
  app5Benefit1: 'Üstün su yalıtımı',
  app5Benefit2: 'Mükemmel aşınma direnci',
  app5Benefit3: 'Azaltılmış geçirgenlik',
  app5Benefit4: 'Islak koşullarda uzun vadeli dayanıklılık',
  
  app6Title: 'Kaplamalar ve Onarımlar',
  app6Desc: 'Beton onarım ve kaplama uygulamaları, mevcut yapılara iyi bağlanan ve çatlamaya direnen malzemeler gerektirir. DYNAMIX çelik donatı telleri bağ dayanımını artırır, büzülme çatlaklarını kontrol eder ve onarım işinin uzun vadeli performansını iyileştirir.',
  app6Benefits: 'Faydalar',
  app6Benefit1: 'Altyapıya mükemmel bağ',
  app6Benefit2: 'Azaltılmış büzülme çatlaması',
  app6Benefit3: 'Daha hızlı uygulama',
  app6Benefit4: 'Uzatılmış onarım ömrü',
  
  // CTA
  ctaTitle: 'Projeniz İçin Doğru Çözümü Bulun',
  ctaSubtitle: 'Teknik ekibimiz, özel uygulamanız için optimal çelik donatı teli spesifikasyonu ve dozajını seçmenize yardımcı olmaya hazırdır.',
  getTechnicalSupport: 'Teknik Destek Alın',

  // More Applications
  moreAppsTitle: 'Daha Fazla Uygulama',
  moreAppsSubtitle: 'Çeşitli inşaat zorlukları için çok yönlü çözümler.',
  
  precastTitle: 'Prefabrik Elemanlar',
  precastDesc: 'Yüksek dayanım ve dayanıklılık gerektiren prefabrik beton paneller, kirişler ve mimari elemanlar için idealdir.',
  
  pavementsTitle: 'Yollar ve Kaplamalar',
  pavementsDesc: 'Beton kaplama performansını artırır, ağır trafik altında çatlamayı azaltır ve hizmet ömrünü uzatır.',
  
  foundationsTitle: 'Temel Döşemeleri',
  foundationsDesc: 'Konut ve ticari temel sistemleri için üstün çatlak kontrolü ve yük dağılımı sağlar.',
  
  waterTanksTitle: 'Su Depoları ve Havuzlar',
  waterTanksDesc: 'Su tutan yapılar için mükemmeldir, çatlak direnci ve su yalıtımı artışı sağlar.',
  
  blastResistantTitle: 'Patlamaya Dayanıklı Yapılar',
  blastResistantDesc: 'Güvenlik açısından kritik altyapı ve askeri uygulamalar için darbe ve patlama direncini artırır.',
  
  seismicTitle: 'Sismik Bölgeler',
  seismicDesc: 'Depreme eğilimli bölgelerdeki yapılar için gelişmiş süneklik ve enerji emilimi.',
};
